import { render, staticRenderFns } from "./SetOfCriteriaObjectSave.vue?vue&type=template&id=4e03b338&"
import script from "./SetOfCriteriaObjectSave.vue?vue&type=script&lang=js&"
export * from "./SetOfCriteriaObjectSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports